import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { adminAPI } from "../../lib/api";

export function StorageWarningBanner() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    adminAPI.getStorageStatus().then(({ data }) => setStatus(data)).catch(() => setStatus(null));
  }, []);

  if (!status?.warning) return null;
  return (
    <div
      data-testid="storage-warning-banner"
      className="flex items-start gap-3 rounded-xl border border-red-500/50 bg-red-500/10 px-4 py-3"
    >
      <AlertTriangle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" />
      <div>
        <p className="text-red-300 font-semibold" data-testid="storage-warning-percent">
          Database {status.percent}% full ({status.used_mb} MB of {status.limit_mb} MB)
        </p>
        <p className="text-red-200/80 text-sm">
          At 100% every save is blocked and users can't create videos or ads. Upgrade the MongoDB Atlas plan or free up space.
        </p>
      </div>
    </div>
  );
}
